<template>
    <div class="bottom_controller">
        <div class="music_bar lv_flex_center" @click="changeMusic">
            <img v-if="isMusic && hasMusic" class="music_bar_ing" src="@/assets/music_open.png" alt="">
            <img v-else src="@/assets/music_closed.png" alt="">
        </div>
        <template v-if="$store.state.routeParams.mode === 'edit'">
            <div v-show="actActived">
                <div class="act">
                    <div v-for="(item, index) in acts" :key="index" :class="{
                        actived: index === actived,
                    }" @click="handleClick(index)">
                        {{ item }}
                    </div>
                </div>
                <div class="act_detail lv_flexalign_center">
                    <coverage v-show="actived === 0" ref="coverage" />
                    <color v-show="actived === 1" ref="color" />
                </div>
            </div>
            <div class="lv_flexalign_center" v-if="actionType == 1">
                <div class="action_btn" @click="actionType = 2">调整</div>
                <div class="lv_flex">
                    <div @click="$refs.choosePop.open(null, 63)">背景</div>
                    <div @click="$refs.choosePop.open(null, 62)">几架</div>
                    <div @click="$refs.choosePop.open(null, 61)">音乐</div>
                </div>
                <div class="action_btn" @click="save">保存</div>
            </div>
            <div class="action_main" v-else>
                <div class="action_back" @click="actionBack"></div>
                <div class="action_list" v-if="actionType == 2">
                    <div class="action_item" @click="actionType = 3">图层顺序</div>
                    <div class="action_item" @click="actionType = 4">调色</div>
                </div>
                <div class="action_list" v-else-if="actionType == 3">
                    <div class="action_item action_item2" @click="changeLayer('top')">置顶</div>
                    <div class="action_item action_item2" @click="changeLayer('bottom')">置底</div>
                    <div class="action_item action_item2" @click="changeLayer('up')">上移</div>
                    <div class="action_item action_item2" @click="changeLayer('down')">下移</div>
                </div>
                <div class="action_list" v-else-if="actionType == 4">
                    <div
                        class="action_item3" 
                        v-for="(item, index) in colorData"
                        :key="index + 'color'"
                        :class="colorIndex == index ? 'action_item3_active' : ''"
                        @click="changeColorIndex(index)"
                    >
                        <div class="action_item3_num">{{item}}</div>
                        <div>{{['亮度', '对比度', '饱和度'][index]}}</div>
                    </div>
                </div>
            </div>
            <div class="color_float" v-if="actionType == 4 && colorIndex != -1">
                <van-slider
                    class="lv_flex_1"
                    v-model="colorData[colorIndex]"
                    @input="handleInput"
                    @change="handleChange"
                    bar-height="4px"
                    inactive-color="#ffffff"
                    active-color="#ffffff"
                    :min="0"
                    :max="200"
                />
            </div>
        </template>
        <choosePop ref="choosePop" />
    </div>
</template>

<script>
import wx from "weixin-js-sdk";
import choosePop from "@/components/material/choosePop";
import copy from "@/components/act/copy";
import coverage from "@/components/act/coverage";
import color from "@/components/act/color";

import { Dialog, Toast } from "vant";
import dayjs from "dayjs";
export default {
    components: {
        choosePop,
        copy,
        coverage,
        color,
    },
    data () {
        return {
            tabs: {
                basicInfo: "基础信息",
                collocation: "插花搭配",
                connotation: "文化内涵",
                colorSuggestion: "色彩搭配",
                compositionSuggestion: "构图建议",
                technicalSuggestion: "技术特点",
            },
            activeNames: ["basicInfo"],
            risoShow: false,
            teacher: {
                show: false,
                desc: null,
                res: "通过",
            },
            form: {
                name: null,
                desc: null,
            },
            inputShow: false,
            coursewareShow: false,
            reqShow: false,
            info: "",
            countdown: "",
            hasDesc: false,
            tId: null,
            actActived: false,
            selectedMaterial: null,
            containerMaterial: null,
            flowerHeightShow: false,
            actived: 0,
            acts: [
                "图层",
                "调色"
            ],
            isMusic: true, // 是否播放音乐
            hasMusic: false,
            actionType: 1,
            colorData: [100, 100, 100],
            brightness: 100,
            contrast: 100,
            saturation: 100,
            colorIndex: -1,
        };
    },
    created () {
        this.$bus.$on("flower-height-show", (val) => {
            this.flowerHeightShow = val;
        });

        this.$bus.$on("container-add", (val) => {
            this.containerMaterial = val;
        });

        this.$bus.$on("flower-choose", (val) => {
            // if (this.selectedMaterial && this.selectedMaterial.id === val.id) {
            //   return;
            // }
            this.selectedMaterial = val;

            if (!val) {
                return;
            }
            this.$refs.winding.init(val);
            this.$refs.flowerHead.init(val);
        });
    
        this.$bus.$on("color-init", (val) => {
            // this.$refs.color.init(val);
            console.log(val)
            this.colorData = [val.brightness, val.contrast, val.saturation];
        });

        this.$bus.$on("addMusic", (val) => {
            this.hasMusic = true;
            this.isMusic = true;
        });
    },
    mounted () {
        console.log(this.$store.state.routeParams);
        if (this.$store.state.routeParams.type !== "practice") {
            this.getRequest(this.$store.state.routeParams.type);
        }
    },
    methods: {
        layerShow (isOne) {
            this.$bus.$emit(
                "layer-show",
                isOne ? (this.selectedMaterial ? this.selectedMaterial.id : "") : ""
            );
        },
        openRiso () {
            if (!this.selectedMaterial) {
                return;
            }
            this.activeNames = ["basicInfo"];
            this.risoShow = true;
        },
        toBack () {
            this.$router.back()
        },
        changeMusic () {
            this.isMusic = !this.isMusic;
            this.$bus.$emit("changeMusicFlag", {
                flag: this.isMusic
            });
        },
        getRequest (type) {
            this.$ajax
                .get(`/${type}/student/getById`, {
                    params: {
                        id: this.$store.state.routeParams.id,
                    },
                })
                .then((res) => {
                    const resData = res.data;
                    this.info = {
                        name: resData[type + "Name"],
                        request: resData[type + "Request"],
                        useMaterials: resData[type + "UseMaterials"],
                        submitEndTime:
                            type === "competition"
                                ? resData.competitionEndTime
                                : resData.submitEndTime,
                        hasTimeout: resData.hasTimeout,
                        coursewareTitle: resData.coursewareTitle,
                        coursewareUrl: resData.coursewareUrl,
                        status: resData.status,
                    };
                    sessionStorage.setItem("startTime", new Date().getTime());
                    this.hasDesc = type === "competition" ? true : resData.hasDesc;
                    sessionStorage.setItem(
                        "limit",
                        JSON.stringify(resData[type + "UseMaterials"][0].useMaterials)
                    );
                    this.$store.commit(
                        "initLimitMaterials",
                        resData[type + "UseMaterials"]
                    );

                    if (this.$store.state.routeParams.mode === "examine") {
                        this.form.name = resData.productName;
                        this.form.desc = resData[type + "Desc"];
                        document.title = resData.productName;
                        if (this.$store.state.routeParams.type === "schoolwork") {
                            this.teacher.desc = resData.schoolworkRemark;
                        }
                    }

                    this.countDown(resData.hasTimeout);
                    this.tId = setInterval(() => {
                        this.countDown(resData.hasTimeout);
                    }, 1000);
                });
        },
        countDown (hasTimeout) {
            var subtime = (dayjs(this.info.submitEndTime) - dayjs()) / 1000;

            var days = parseInt(subtime / 86400);
            var hours = parseInt(subtime / 3600) - 24 * days;
            var minutes = parseInt((subtime % 3600) / 60);
            var seconds = parseInt(subtime % 60);

            if (
                hours <= 0 &&
                minutes <= 0 &&
                seconds <= 0 &&
                this.$store.state.routeParams.mode === "edit"
            ) {
                clearInterval(this.tId);
                if (hasTimeout) {
                    this.countdown = "已经超时";
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: "作答时间已到",
                    }).then(() => {
                        this.wxReturn();
                    });
                }
            } else {
                this.countdown = `${days}天 ${hours}小时 ${minutes}分 ${seconds} 秒`;
            }
        },
        wxReturn () {
            wx.miniProgram.navigateBack({});
        },
        handleClick (index) {
            this.actived = index;
            if (index === 4) {
                this.$refs.choosePop.open({
                    classifyId1: 1,
                    id: this.selectedMaterial ? this.selectedMaterial.id : null,
                });
            }
        },
        save () {
            if (this.$store.state.routeParams.type === "practice") {
                this.$bus.$emit("saveHrss", "practice");
            } else {
                if (!this.form.name || (!this.form.desc && this.hasDesc)) {
                    Toast("请点击右下角，完善要求");
                    return;
                }

                Dialog.confirm({
                    title: "提交" + this.$store.state.routeParams.text,
                    message: `提交前请检查是否完成，确认是否提交${this.$store.state.routeParams.text}？`,
                })
                    .then(() => {
                        this.$bus.$emit("save", "work", this.form);
                    })
                    .catch(() => { });
            }
        },
        changeLayer(action) {
            this.$bus.$emit(
                "setCoverage",
                action
            );
        },
        actionBack() {
            switch (+this.actionType) {
                case 2:
                    this.actionType = 1;
                    break;
                case 3:
                    this.actionType = 2;
                    break;
                case 4:
                    this.colorIndex = -1;
                    this.actionType = 2;
                    break;
            }
        },
        changeColorIndex(index) {
            this.colorIndex = index;
        },
        handleInput() {
            switch (+this.colorIndex) {
                case 0:
                    this.$bus.$emit("setBrightness", this.colorData[0]);
                    break;
                case 1:
                    this.$bus.$emit("setContrast", this.colorData[1]);
                    break;
                case 2:
                    this.$bus.$emit("setSaturation", this.colorData[2]);
                    break;
            }
        },
        handleChange() {
            switch (+this.colorIndex) {
                case 0:
                    this.$bus.$emit("setBrightness", this.colorData[0]);
                    break;
                case 1:
                    this.$bus.$emit("setContrast", this.colorData[1]);
                    break;
                case 2:
                    this.$bus.$emit("setSaturation", this.colorData[2]);
                    break;
            }
        },
    },
};
</script>
<style lang="scss">
.slider_text {
    width: rem(90);
    text-align: center;
}

.van-collapse-item {
    .van-cell__title {
        text-align: center;
    }
}

.exam_bar {
    margin: rem(20);
    background: #fff;
    font-weight: bold;
    border-radius: rem(10);
    border: 1px solid #dedede;
    padding: rem(20) 0;

    >div {
        line-height: rem(50);
        font-size: rem(28);
        flex: 1;
        text-align: center;

        +div {
            border-left: 1px solid #dcdcdc;
        }
    }
}

.act_button {
    flex: 1;
    line-height: rem(40);
    border: 1px solid #dcdcdc;
    border-radius: rem(14);
    text-align: center;
    font-size: rem(24);
    background: #fff;
}

.act_button+.act_button {
    margin-left: rem(20);
}

.actived {
    background: #e8efd5;
}
</style>
<style lang="scss" scoped>
.mb-10 {
    margin-bottom: rem(10);
}

.selected_bar {
    width: rem(90);
    padding: rem(10) rem(5);
    box-sizing: border-box;
    position: fixed;
    top: rem(280);
    border-radius: rem(14);
    left: rem(27);
    background: #f7f7f7;
    border: 1px solid #dcdcdc;
    font-size: rem(20);
    color: #333;
}

.back_bar {
    position: fixed;
    right: rem(18);
    top: rem(28);
    height: rem(53);
    width: rem(160);
    border: 1px solid #dcdcdc;

    border-radius: rem(27);
    background: #fff;
    color: #d6d6d6;

    >div {
        width: rem(16);
        height: rem(16);
        background: #dcdcdc;
        border-radius: 50%;
        margin: 0 rem(15);
    }
}
.music_bar {
    position: fixed;
    right: rem(18);
    top: rem(120);
    height: rem(53);
    width: rem(53);

    border-radius: rem(27);
    img {
        height: rem(53);
        width: rem(53);
    }
}
.music_bar_ing {
    animation: rotate360 3s linear infinite;
}
@keyframes rotate360 {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.tool_bar {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}
.tool_item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: rem(53);
    width: rem(160);
    border: 1px solid ;

    border-radius: rem(10);
    background: #fff;
    // color: #d6d6d6;

}
.riso_bar_actived {
    color: #6e9f21;
    background: #e8efd5;

    >div {
        background: #6e9f21;
        animation: colorChange 1.5s infinite;
    }
}

.design_bar {
    position: fixed;
    right: rem(18);
    top: rem(100);
    height: rem(53);
    width: rem(160);
    border-radius: rem(27);

    color: #6e9f21;
    background: #e8efd5;

    >div {
        background: #6e9f21;
        animation: colorChange 1.5s infinite;
    }
}
@keyframes colorChange {
    0% {
        background: #6e9f21;
    }

    50% {
        background: #ff8f2f;
    }

    100% {
        background: #6e9f21;
    }
}

.input_pop {
    padding: rem(20) 0;
}

.req_poup {
    padding: rem(20) rem(29) rem(59) rem(29);

    .label {
        font-size: rem(28);
        padding: rem(22) 0 rem(11) 0;
        font-weight: bold;
    }

    .text {
        font-size: rem(26);
        color: #666;
        line-height: rem(40);
    }

    .link {
        font-size: rem(26);
        color: #007cd9;

        i {
            margin-right: rem(4);
        }

        padding-bottom: rem(29);
        border-bottom: 1px solid #eee;
    }
}

.act_text_actived {
    position: relative;

    &:after {
        content: "";
        position: absolute;
        width: rem(20);
        height: rem(5);
        background: #6e9f21;
        left: rem(18);
        bottom: rem(-10);
    }
}

.bottom_controller {
    position: fixed;
    bottom: 0;
    z-index: 99;
    width: 100vw;
    height: rem(115);
    background: #fff;

    >.lv_flexalign_center {
        justify-content: space-between;
        // width: 100%;
        height: rem(115);
        padding: 0 rem(40);
        font-size: rem(30);
        font-weight: bold;

        .lv_flex {
            font-size: rem(26);
            font-weight: normal;

            >div+div {
                margin-left: rem(65);
            }
        }
    }
    .action_main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: rem(115);
        background: #31A458;
    }
    .action_back {
        display: flex;
        justify-content: center;
        align-items: center;
        width:rem(80);
        height: rem(115);
        font-size: rem(32);
        color: #fff;
        border-right: 1px solid #fff;
    }
    .action_back::before {
        content: '';
        width: rem(20);
        height: rem(20);
        border-top: rem(3) solid white;
        border-left: rem(3) solid white;
        transform: rotate(-45deg);
        margin-right: -rem(10);
    }
    .action_list {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex: 1;
    }
    .action_item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: rem(268);
        height: rem(60);
        background: #F7F7F7;
        border-radius: rem(8);
        font-size: rem(28);
        color: #31A458;
    }
    .action_item2 {
        width: rem(147);
        height: rem(60);
    }
    .action_item3 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: rem(28);
        color: #FFFFFF;
    }
    .action_item3_num {
        font-size: rem(48);
    }
    .action_item3_active {
        color: #FFEC00;
    }
    .action_btn {
        width: rem(137);
        height: rem(60);
        background: #31A458;
        border-radius: rem(30);
        text-align: center;
        line-height: rem(60);
        font-size: rem(28);
        color: #FFFFFF;
    }
    .color_float {
        position: fixed;
        bottom: rem(160);
        left: 20vw;
        width: 60vw;
    }
    .act {
        white-space: nowrap;
        overflow-x: auto;
        padding: 0 rem(340);

        &::-webkit-scrollbar {
            display: none;
        }

        >div {
            line-height: rem(70);
            width: rem(70);
            font-size: rem(24);
            background: #fff;
            border-radius: 50%;
            border: 1px solid #f1f1f1;
            text-align: center;
            display: inline-block;

            +div {
                margin-left: rem(20);
            }
        }

        .actived {
            background: #e8efd5;
            color: #6e9f21;
        }

        .hide {
            display: none;
        }
    }

    .act_detail {
        height: rem(150);

        >div {
            width: 100vw;
        }
    }

    .act_layout {
        padding: 0 rem(40);
    }
}

.work_bar {
    background: #fff;
    padding: rem(20) 0;

    >div {
        flex: 1;
        height: rem(50);
        color: #666;
        font-size: rem(28);

        i {
            margin-right: rem(17);
            color: #2e3531;
            font-size: rem(30);
        }

        +div {
            border-left: 1px solid #dcdcdc;
        }
    }
}

.count_down {
    position: fixed;
    font-size: rem(26);
    top: rem(40);
    width: rem(400);
    text-align: center;
    left: rem(200);
}

#ls_vedio {
    width: 100%;
    height: 50vh;
}
</style>